import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { NoResultsCard } from "components/common/CardStyles";

const CardNoResultsWrapper = ({ content, message, children }) => {
  const { t } = useTranslation();

  const isContentEmpty = useMemo(() => content && content.length === 0, [content]);
  if (!isContentEmpty) return <div>{children}</div>;
  return <NoResultsCard>{message ?? t("ResultsNotFound")}</NoResultsCard>;
};

CardNoResultsWrapper.propTypes = {
  content: PropTypes.array,
  message: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired])
};

export default CardNoResultsWrapper;
